import { Component, OnInit } from '@angular/core'

@Component({
  standalone: false,

  selector: 'vs-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.scss'],
})
export class QuickLinksComponent implements OnInit {
  quoteCartStatus: any

  constructor() {}

  ngOnInit(): void {}

  setQuoteCart() {
    this.quoteCartStatus = sessionStorage.setItem('quoteCartValue', 'true')
  }

  goTobomLpn(){
    let bomLpnURL = "https://www.valvcentral.com/valves/#/valvcentral/cases";
    window.open(bomLpnURL ,'_blank');
  }

  goToretroUpgrade(){
    let retroURL = "https://apps.powerapps.com/play/e/5d1a8694-d89d-405d-885f-c25ec887542e/a/3fbef6ec-b40e-4901-b910-2614a03af738?tenantId=d584a4b7-b1f2-4714-a578-fd4d43c146a6&q";
    window.open(retroURL ,'_blank');
  }

  goToRequestTraining(){
    let trainingURL = "https://nam12.safelinks.protection.outlook.com/?url=https%3A%2F%2Fforms.cloud.microsoft%2Fr%2FPS2MSmqN4N&data=05%7C02%7CAmisha.Shaw%40bakerhughes.com%7C5844dad688634e0894d708df17f6bfe6%7Cd584a4b7b1f24714a578fd4d43c146a6%7C0%7C0%7C639256020729626701%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=UZhWWqTNVCaE7izuPtgNnhApEF1zL1icRn%2FP0MD8gXk%3D&reserved=0";
    window.open(trainingURL ,'_blank');
  }
}
